<div class="page">
  <div class="title-wrap grid-span-all">
    <h1 class="grid-span-all">{{'dashboard_title' | translate}}</h1>
    <div class="profile-wrap d-flex align-items-center">
      <app-profile-section></app-profile-section>
    </div>
  </div>
  <div class="grid">
    <!-- stats today -->
    <h2 class="grid-span-all">{{'dashboard_today' | translate}}</h2>
    <div class="panel panel-stat panel-stat--sent">
      <div class="title"
        [ngStyle]="{'color': ('sent' | eventColor)}">{{'dashboard_sent'
      | translate}}</div>
      @if (statsToday.sent !== undefined) {
        <div
        class="value">{{statsToday.sent || 0}}</div>
      }
      @if (statsToday.sent === undefined) {
        <app-spinner
          [noMargin]="true"
        [alignLeft]="true"></app-spinner>
      }
    </div>
    <div class="panel panel-stat panel-stat--delivered">
      <div class="title"
        [ngStyle]="{'color': ('delivered' | eventColor)}">{{'dashboard_delivered'
      | translate}}</div>
      @if (statsToday.delivered !== undefined) {
        <div
          class="value">{{statsToday.delivered ||
        0}}</div>
      }
      @if (statsToday.delivered === undefined) {
        <app-spinner
          [noMargin]="true"
        [alignLeft]="true"></app-spinner>
      }
    </div>
    <div class="panel panel-stat panel-stat--opened">
      <div class="title"
        [ngStyle]="{'color': ('open' | eventColor)}">{{'dashboard_opened'
      | translate}}</div>
      @if (statsToday.opened !== undefined) {
        <div
          class="value">{{statsToday.opened ||
        0}}</div>
      }
      @if (statsToday.opened === undefined) {
        <app-spinner
          [noMargin]="true"
        [alignLeft]="true"></app-spinner>
      }
    </div>
    <div class="panel panel-stat panel-stat--bounced">
      <div class="title"
        [ngStyle]="{'color': ('bounce' | eventColor)}">{{'dashboard_bounced'
      | translate}}</div>
      @if (statsToday.bounced !== undefined) {
        <div
          class="value">{{statsToday.bounced ||
        0}}</div>
      }
      @if (statsToday.bounced === undefined) {
        <app-spinner
          [noMargin]="true"
        [alignLeft]="true"></app-spinner>
      }
    </div>
    <!-- stats -->
    <h2 class="grid-span-all">{{'dashboard_stats' | translate}} <span
      class="range" [class.saving]="!ready"><span
      [class.saving]="loading" class="icon-wrap"
      (click)="prevMonth()"><i
    class="im-icon im-icon-chev-left"></i></span>{{dateRange}}<span
    [class.saving]="loading || !allowNextMonth"
    class="icon-wrap" (click)="nextMonth()"><i
  class="im-icon im-icon-chev-right"></i></span></span></h2>
  <div class="panels-left">
    <!-- projects -->
    <div class="panel panel-data panel-data--projects"
      [class.loading]="!ready" [class.saving]="loading">
      <div class="title">{{'dashboard_projects' | translate}}</div>
      <!-- table -->
      @if (ready && projectStats?.length) {
        <table class="table--detail table--detail--dash">
          <tr>
            <th width="38%">{{'dashboard_th_project' |
            translate}}</th>
            <th width="30%">{{'dashboard_th_environment' |
            translate}}</th>
            <th width="16%">{{'dashboard_th_sent' |
            translate}}</th>
            <!-- <th width="16%">{{'dashboard_th_bounced' | translate}}</th> -->
          </tr>
          @for (project of projectStats; track project) {
            <tr>
              <td>{{project.project}}</td>
              <td
              class="td-passive">{{project.environment}}</td>
              <td class="td-passive">{{project.sent}}</td>
              <!-- <td class="td-passive">{{project.bounced}}</td> -->
            </tr>
          }
        </table>
        <button (click)="export('projects')"
          [class.disabled]="saving.projects"
          class="button-link fontsize-s export-btn">
          @if (!saving.projects) {
            <i
            class="im-icon im-icon-download"></i>
          }
          @if (saving.projects) {
            <app-inline-spinner
            class="mr-1"></app-inline-spinner>
          }
          <span class="underline">{{'dashboard_export_btn' |
          translate}}</span>
        </button>
      }
      <!-- empty -->
      @if (ready && !projectStats?.length) {
        <app-empty-state
        [value]="'dashboard_emptystate' | translate"></app-empty-state>
      }
      <!-- spinner -->
      @if (!ready) {
        <app-spinner [centerVertically]="true"></app-spinner>
      }
    </div>
    <!-- clients -->
    @if (internal) {
      <div class="panel panel-data panel-data--clients"
        [class.loading]="!ready" [class.saving]="loading">
        <div class="title">{{'dashboard_clients' | translate}}</div>
        <!-- table -->
        @if (ready && clientStats?.length) {
          <table class="table--detail table--detail--dash">
            <tr>
              <th width="68%">{{'dashboard_th_client' |
              translate}}</th>
              <th width="16%">{{'dashboard_th_sent' |
              translate}}</th>
              <!-- <th width="16%">{{'dashboard_th_bounced' |
            translate}}</th> -->
          </tr>
          @for (client of clientStats; track client) {
            <tr>
              <td>{{client.client}}</td>
              <td class="td-passive">{{client.sent}}</td>
              <!-- <td class="td-passive">{{client.bounced}}</td> -->
            </tr>
          }
        </table>
        <button (click)="export('clients')"
          [class.disabled]="saving.clients"
          class="button-link fontsize-s export-btn">
          @if (!saving.clients) {
            <i
            class="im-icon im-icon-download"></i>
          }
          @if (saving.clients) {
            <app-inline-spinner
            class="mr-1"></app-inline-spinner>
          }
          <span class="underline">{{'dashboard_export_btn' |
          translate}}</span>
        </button>
      }
      <!-- empty -->
      @if (ready && !clientStats?.length) {
        <app-empty-state
        [value]="'dashboard_emptystate' | translate"></app-empty-state>
      }
      <!-- spinner -->
      @if (!ready) {
        <app-spinner [centerVertically]="true"></app-spinner>
      }
    </div>
  }
</div>
@if (false) {
  <div class="panels-right">
    <!-- activity -->
    <div class="panel panel-data panel-data--activity">
      <div class="title">{{'dashboard_activity' | translate}}</div>
      Tons of activity...
    </div>
  </div>
}
</div>
</div>